import styled from "styled-components";
import FlexBox from "../../../elements/v2/Box/FlexBox";

export const StepWrapper = styled(FlexBox)`
  width: 100%;
  flex-direction: column;
  align-items: center;
`;
